import React from 'react'
import Box from '@mui/material/Box'
import { t } from '@lingui/macro'
import { ContentShare, FeaturedRemoteVideos, LocalVideo, RemoteVideos, VideoGrid } from 'amazon-chime-sdk-component-library-react'
import LocalVideoOff from '@/components/ui/meeting/LocalVideoOff'

import { useVideoTileGridLayout, type VideoTileGridLayoutMode } from './useVideoTileGridLayout'
import { gridContainerSx, localOffSx } from './videoTileGrid.styles'

type VideoTileGridProps = {
  layout: VideoTileGridLayoutMode
  localAttendeeName?: string
  noRemoteVideoView?: React.ReactNode
}

export default function VideoTileGrid({ layout, localAttendeeName, noRemoteVideoView }: VideoTileGridProps) {
  const localName = localAttendeeName ?? t`Me`
  const { isVideoEnabled, isDesktop, splitView, gridSize, gridLayout, localCss, showPlaceholder } = useVideoTileGridLayout(layout)

  return (
    <Box sx={gridContainerSx(splitView)}>
      <VideoGrid layout={gridLayout} size={gridSize}>
        {showPlaceholder && noRemoteVideoView}
        <ContentShare css="grid-area: ft;" />
        {layout === 'featured' && !splitView ? <FeaturedRemoteVideos /> : <RemoteVideos />}
        <LocalVideo nameplate={t`Me`} css={localCss} />
        {!isVideoEnabled && !isDesktop && (
          <Box sx={localOffSx}>
            <LocalVideoOff name={localName} />
          </Box>
        )}
      </VideoGrid>
    </Box>
  )
}
